import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import b from 'b_';

import getClosestElement from 'client/helpers/getClosestElement';
import SideNav from '@components/side-nav';

import './side-nav-container.css';

interface State {
    sideNavIsOpened: boolean;
}

export interface StateProps {
    sideNavIsOpened: boolean;
}

export interface DispatchProps {
    toggleSideNav(state: boolean): void;
}

export interface ComponentProps {
    togglerClass: string;
}

export type Props = DispatchProps & StateProps & ComponentProps & RouteComponentProps<any>;

const class_ = b.with('side-nav-container');

export default class SideNavContainer extends Component<Props, State> {
    public componentDidMount() {
        document.addEventListener('click', this.onDocumentClick);
    }

    public componentWillUnmount() {
        document.removeEventListener('click', this.onDocumentClick);
    }

    public onDocumentClick = ({ target }: MouseEvent) => {
        if (getClosestElement(target, class_('side-nav'))
            || getClosestElement(target, this.props.togglerClass)) {
            return;
        }

        this.props.toggleSideNav(false);
    };

    public onSideNavClose = () => {
        this.props.toggleSideNav(false);
    };

    public onSideNavSearch = (search: string) => {
        this.props.toggleSideNav(false);
        this.props.history.push(`/search?text=${encodeURIComponent(search)}`);
    };

    public render() {
        const { sideNavIsOpened } = this.props;

        return (
            <div className={class_({ opened: sideNavIsOpened })}>
                <div className={class_('overlay')} />
                <SideNav
                    className={class_('side-nav')}
                    onSearch={this.onSideNavSearch}
                    onClose={this.onSideNavClose}
                />
            </div>
        );
    }
}
